import { createReducer, on } from '@ngrx/store';
import { setItemPackageAction, resetPackageActions } from './confirm-package.actions';

export interface ConfirmPackageState {
  [itemId: string]: {
    type: string;
    action: string;
    products?: any[];
  };
}

const initialState: ConfirmPackageState = {};

export const confirmPackageReducer = createReducer(
  initialState,
  on(setItemPackageAction, (state, { itemId, itemType, action, products }) => ({
    ...state,
    [itemId]: {
      type: itemType,
      action,
      ...(products ? { products } : {}),
    },
  })),
  on(resetPackageActions, () => initialState)
);